// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__laDGh"};